<template>
    <div>
        <div class="tv-nav">
            <div class="logo">
                <img :src="logo" @click="toHome()"/>
            </div>
        </div>
        <div class="about-app-inset">
            <image-bg 
                :title="'Contact Us'" 
                :min-title="'お問い合わせ'"
                align="right"
                :bg-images="banner"
                color="#000"
            ></image-bg>
            <div class="msg-area">
                <div class="msg-title">
                    KAITEKI TECH CO.,LIMITED
                </div>
                <div class="msg-text">
                    <div class="text-inset" v-for="(n, index) in msgList" :key="index">
                        <label>{{ n.label }}</label>
                        <span>{{ n.text }}</span>
                    </div>
                </div>
                <div class="btn-area">
                    <div class="icon" v-for="(n, index) in iconList" :key="index">
                        <img :src="iconSeclected === index ? n.selected : n.nomal" @click="iconSeclected = index"/>
                    </div>
                </div>
            </div>
            <tv-footer></tv-footer>
        </div>
    </div>
</template>
<script>
import imageBg from '../../components/image-bg'
import tvFooter from '../home/modules/footer'
import { banner,iconList } from './images/index'
import logo from '../../images/logo.png'
import publicMinxin from '../public-minxin'
export default {
    mixins: [publicMinxin],
    components: {
        imageBg,
        tvFooter
    },
    data () {
        return {
            banner,
            logo,
            iconList,
            iconSeclected: null,
            msgList: [
                {
                    label: 'Web',
                    text: 'https://www.kaitekitv.com'
                },
                {
                    label: 'E-mail',
                    text: 'admin@kaitekitv.com'
                }
            ]
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {

        }
    }
}
</script>
<style scoped>
.about-app-inset {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 60px;
}
.msg-area {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 20px;
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
}
.tv-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    z-index: 999;
    border-bottom: solid 2px  #D1D1D1;;
}
.logo img {
    display: block;
    height: 100%;
}
.msg-title {
    font-size: 16px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: normal;
    color: #010101;
    margin-bottom: 10px;
}
.text-inset label{
    width: 65px;
    height: 20px;
    border-radius: 5px;
    display: inline-block;
    text-align: center;
    background: #FDB819;
    color: #000;
    margin-right: 10px;
}
.text-inset {
    margin-bottom: 10px;
}
.btn-area {
    text-align: center;
}
.icon {
    display: inline-block;
    margin: 5px;
    width: 30px;
    height: 30px;
}
.icon img {
    display: block;
    width: 100%;
}
</style>